import classNames from 'classnames';
import * as React from 'react';
import css from './ExploreSection.module.scss';

interface Props extends React.HTMLProps<{}> {
  isFull?: boolean;
}

class ExploreSection extends React.PureComponent<Props> {
  public render() {
    const classes = classNames(css.ExploreSection, {
      [css.isFull]: this.props.isFull,
    });

    return (
      <section className={classes}>
        <div className={css.ExploreSection__Inner}>{this.props.children}</div>
      </section>
    );
  }
}

export default ExploreSection;
